	$(document).ready(function(){
		var readmore = false;
		var readMoreButtonEle = $("#readmore-btn");
		var readMoreButtonContainerEle = $("#readmore-btn-container");
		var readMoreContentEle = $("#readmore-container");
		var readLessContentClass = "lesscontent";
		var readMoreText = "| + Read More |";
		var readLessText = "| - Read Less |";

		readMoreButtonEle.click(function(){
			if(readmore){
				readMoreButtonEle.text(readMoreText);
				readMoreContentEle.addClass(readLessContentClass);
				readMoreButtonContainerEle.addClass(readLessContentClass);
			}else{
				readMoreButtonEle.text(readLessText);
				readMoreContentEle.removeClass(readLessContentClass);
				readMoreButtonContainerEle.removeClass(readLessContentClass);
			}
			readmore = !readmore;
		});
	});

